import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { TableBlockPayload } from "@/features/assistant/types";

function format(value: unknown) {
  if (value === null || value === undefined) return "—";
  if (typeof value === "number")
    return value.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
  if (typeof value === "boolean") return value ? "Sim" : "Não";
  if (Array.isArray(value)) return value.join(", ");
  return String(value);
}

export function BlockTable({ payload }: { payload: TableBlockPayload }) {
  return (
    <div
      className="overflow-x-auto rounded-md border"
      data-testid="assistant-block-table"
    >
      <Table>
        <TableHeader>
          <TableRow>
            {payload.columns.map((c) => (
              <TableHead key={c.key} className="whitespace-nowrap">
                {c.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {payload.rows.map((row, i) => (
            <TableRow key={i}>
              {payload.columns.map((c) => (
                <TableCell key={c.key} className="whitespace-nowrap">
                  {format(row[c.key])}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
